import { db, stage , cvGetDataUndoPush } from './draw';
import * as createjs from "createjs-module";
import * as symConst from 'src/app/shared/constant/canvasSymTypes'; 
import {PenItemType, ZERO_PT, cvPointType} from 'src/app/shared/constant/drawConstants.ts'; 
//import * as drawConst from 'src/app/shared/constant/draw-tool-api'; 
import {DrawToolType,DT_DRAW_MODE,DT_DRAW_MODE_2,DT_EDIT_MODE,DT_TOOL_POINT,
    DT_TOOL_LINE,DT_TOOL_MULTI_LINE,DT_TOOL_FREEHAND,DT_TOOL_SHAPE,DT_TOOL_ERASER,
    DT_END_POINT_NONE, DT_MULTI_LINE_JOINT_NONE,DT_SHAPE_CIRCLE, DT_SHAPE_SQUARE,
    DT_SHAPE_RECT,DT_SHAPE_RIGHT_TRIANGLE, DT_SHAPE_TRIANGLE,
    DT_SHAPE_OUTLINE, DT_SHAPE_SOLID,DT_LINE_OPACITY_SOLID, DT_LINE_SIZE_1, 
    DT_COLOR_1, DT_HIGHLIGHT_LINE_SIZE_1, DT_COLOR_15, DT_LINE_TYPE_SOLID,
    DT_HIGHLIGHT_OFF, DT_END_POINT_DOT, DT_END_POINT_OPEN_DOT,DT_END_POINT_ARROW,
    DT_END_POINT_ARROW_DOT,DT_HIGHLIGHT_ON,DT_MULTI_LINE_JOINT_DOT,
    DT_MULTI_LINE_CLOSED}
    from 'src/app/shared/constant/draw-tool-api'; 
import {
    CvDrawingBoard, MathFileType, STATE_NORMAL, STATE_IN_PEN_TOOL, MProbType, MLineType, MBranchType,
    SymbolType, SymbolLong, SymbolSimple
  } from 'src/assets/js/cv-classes.js';
import {getCorrectXY,pushPenItemPt, adjustStart, adjustEnd,setPenShapeFill,setPenShapeStroke,checkPenShapeStroke} 
    from 'src/assets/js/cv-helpers.js';
import {drawSavedPenItem, watchMultiLine  }
    from 'src/assets/js/cv-pen-tool.js';

    export function watchEdit(e) {
        //console.log("got WATCH EDIT press down");

        let canvas = document.getElementById('drawingboard');
        canvas.classList.remove("default-cursor")
        canvas.classList.add("grab-cursor");
        stage.update();
    
        let curPt = getCorrectXY(db.penLayer);
        checkAndEdit(curPt);
    
        db.penLayer.addEventListener('pressmove', function (e) {
    
            curPt = getCorrectXY(db.penLayer);
            checkAndEdit(curPt);   
            stage.update();
        })  
        db.penLayer.addEventListener("pressup", function (e) {
            db.penLayer.removeAllEventListeners('pressmove');
            db.penLayer.removeAllEventListeners('pressup');
        })
    }    
    
    
    // when starting the edit menu, watch for the user selecting pen items
    export function checkAndEdit(point) {
    
        let penItem;
        let topObj = db.penLayer.getObjectUnderPoint(point.x,point.y);
 
        // watch for selections other than the background
        if (topObj != null && topObj.name != "pen background") {
            //console.log("IN checkandEdit", topObj.name);
            //console.log("in checkAndEdit", topObj);
            // if this is the first time selecing an object - either a different one or the first time editing
            // then select the pen object
            if ((topObj.name != db.curPenIndex) ||
                 (topObj.name == db.curPenIndex && !db.penItemList[db.curPenIndex].pointsVisible)) {
    
                // if there is a prior pen object with editing shapes displayed,then remove those    
                if (db.curPenIndex >= 0 && db.penItemList[db.curPenIndex].pointsVisible) {
                    hideEditPoints(db.penItemList[db.curPenIndex]);
                }
    
                // change the setting to make the selected pen item the current one
                penItem = db.penItemList[topObj.name];
                db.curPenIndex = topObj.name;
                db.penLayer.setChildIndex(penItem.container, db.penLayer.numChildren-1);


                if (topObj.name == null || topObj.name < 0) {
                    console.log("FOUND ERROR IN OBJ NAME");
                    return;
                }
              
                db.curPenContainer = db.penItemList[topObj.name].container;
                db.curPenObj = penItem.shape;
               
    
                // add edit points to lines and shapes but not freehand or points
                if (penItem.dt.toolType == DT_TOOL_MULTI_LINE || penItem.dt.toolType == DT_TOOL_LINE ||
                    penItem.dt.toolType == DT_TOOL_SHAPE) {
                    
                    // if pen object was drawn in this session then will have edit points already, then just add visibility and watcher,
                    // otherwise create them
                    if (penItem.pointsObj.length > 0) {
                        showEditPoints(penItem);
                    }
                    else {
                        watchEditDragPoints(penItem); 
                    }
                }
                // set up a watcher to watch on a background shape to watch for whole pen item drags
                let backShape = setMoveBackground(penItem);
                penItem.pointsVisible = true;
                
            }
    
            stage.update();
        }
        //console.log("erase",db.penItemList);
    }  
    


// display editing dots over lines and shape points, and watch for the user dragging those
export function watchEditDragPoints(penItem) {

    let length = ((penItem.dt.toolType == DT_TOOL_SHAPE && penItem.dt.shapeType != DT_SHAPE_CIRCLE) ||
                    (penItem.dt.toolType == DT_TOOL_MULTI_LINE && penItem.dt.jointType == DT_MULTI_LINE_CLOSED)) ? 
                    penItem.points.length-1 : penItem.points.length;
                    
    let startDot = 0;
    let lastDot = length;
    // for squares and rectangles add just one edit point on opposite corner, which is point index 2
    if (penItem.dt.toolType == DT_TOOL_SHAPE && (penItem.dt.shapeType == DT_SHAPE_RECT ||
            penItem.dt.shapeType == DT_SHAPE_SQUARE)) {
        startDot = 2;
        lastDot = 3;
    }
    let radius;

    
    for (let i = startDot; i < lastDot; i++) {
        let editDot = new createjs.Shape();
       // let canvas = document.getElementById('drawingboard');
        
        //canvas.classList.remove("default-cursor");
        //canvas.classList.add("grab-cursor");
        //editDot.cursor = "grab";
        editDot.name = db.curPenIndex; 
        editDot.ptIndex = i; 
        editDot.x = penItem.points[i].x+penItem.x;
        editDot.y = penItem.points[i].y+penItem.y;
        penItem.container.addChild(editDot);
        penItem.pointsObj[i] = editDot;

        //setPenShapeFill(newShape,penItem.dt,true);
        if (penItem.dt.highlight == DT_HIGHLIGHT_OFF || penItem.dt.toolType == DT_TOOL_SHAPE) {
            radius = penItem.dt.regLineSize;
        }
        else {
        radius = penItem.dt.highlightLineSize;
        }
        // adjust so edit points dont't end up tiny or huge
        radius = Math.min(Math.max(radius, 12),20)/ stage.scaleX;
   
        editDot.graphics.beginFill("#00AB66"); // go green
        editDot.graphics.drawCircle(0,0, radius);
        editDot.addEventListener("mousedown", handleMovePoint);
    }
    penItem.pointsVisible = true;
    stage.update();
}

// make editing points not visiable and mark the penItem as not showing editing (move shape or edit points)
export function hideEditPoints(penItem) {
    //stage.enableMouseOver(0);
    penItem.pointsVisible = false;
    if (penItem.dt.toolType == DT_TOOL_LINE || penItem.dt.toolType == DT_TOOL_MULTI_LINE ||
        penItem.dt.toolType == DT_TOOL_SHAPE) {
    
        for (let i=0; i <= penItem.pointsObj.length-1; i++) {
            if (penItem.pointsObj[i] != null) {
                penItem.pointsObj[i].visible = false;
                penItem.pointsObj[i].removeAllEventListeners();
            }
        
        }
        stage.update();
    }
    // also remove the move background object
    clearPenMoveObj(db.penItemList[db.curPenIndex]);

}

export function showEditPoints(penItem) {
    for (let i=0; i <= penItem.pointsObj.length-1; i++) {
        if (penItem.pointsObj[i] != null) {
            penItem.pointsObj[i].visible = true;
            penItem.pointsObj[i].addEventListener("mousedown", handleMovePoint);
        }
    }
    stage.update();


}
// handle dragging edit points in shapes
export function handleMovePoint(e) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    db.penLayer.removeAllEventListeners("click");

    let canvas = document.getElementById('drawingboard');
    let moveLast = false;

    // e.target hold the createjs object for the editing dot on the point selected
    //console.log("got move point press",e.target.name,  e.target.x);
    let curPen = db.penItemList[db.curPenIndex];  
    let curPenObj = db.penItemList[db.curPenIndex].shape;

    let ptIndex = e.target.ptIndex;  // CHANGED from .name
    let startPt = getCorrectXY(db.penLayer); 
    let startDotX = e.target.x;
    let startDotY = e.target.y;
    let inSquare = (curPen.dt.toolType == DT_TOOL_SHAPE && curPen.dt.shapeType == DT_SHAPE_SQUARE);
    let inRect = (curPen.dt.toolType == DT_TOOL_SHAPE && curPen.dt.shapeType == DT_SHAPE_RECT);

    if ((ptIndex == 0) && curPen.points[curPen.points.length-1].x == curPen.points[ptIndex].x
                           && curPen.points[curPen.points.length-1].y == curPen.points[ptIndex].y) {
        moveLast = true;
    }

    if (curPen.backgroundObj != null) {
        curPen.backgroundObj.removeAllEventListeners();
        curPen.container.removeChild(curPen.backgroundObj);
        stage.update();
    }

    db.penLayer.addEventListener("pressmove", function (e) {

        canvas.classList.remove("grab-cursor");
        canvas.classList.add("grabbing-cursor");
        //e.target.cursor = "grabbing";
        
        let nextPt = getCorrectXY(db.penLayer); 
        //console.log("curpenobj", curPenObj.x, curPenObj.y, "container", curPen.container.x, curPen.container.y);
        //console.log("nextPt.x, nextPt.y", e.target.x, e.target.y, nextPt.x, nextPt.y);

        e.target.x = nextPt.x - curPen.container.x;  //startDotX + (nextPt.x-startPt.x);
        e.target.y = nextPt.y- curPen.container.y; //startDotY + (nextPt.y-startPt.y);
        curPen.points[ptIndex].x = e.target.x - curPenObj.x; 
        curPen.points[ptIndex].y = e.target.y - curPenObj.y; 

        if (curPen.dt.toolType == DT_TOOL_SHAPE && curPen.dt.shapeType == DT_SHAPE_CIRCLE) {
            curPen.radius = Math.sqrt(Math.pow(e.target.x - curPenObj.x, 2) + Math.pow(e.target.y - curPenObj.y, 2));
        }
        else if (inRect || inSquare) {
            curPen.width = nextPt.x - curPen.shape.x - curPen.container.x;
            curPen.height = nextPt.y - curPen.shape.y - curPen.container.y;
            if (inSquare)  {
                let size = Math.min(Math.abs(curPen.width),Math.abs(curPen.height));
                curPen.width = size * Math.sign(curPen.width);
                curPen.height = size * Math.sign(curPen.height);
                e.target.x = curPen.shape.x + curPen.width;
                e.target.y = curPen.shape.y + curPen.height;
            }
        }
        else {
            curPen.points[ptIndex].x =  nextPt.x-curPenObj.x - curPen.container.x;  
            curPen.points[ptIndex].y =  nextPt.y-curPenObj.y- curPen.container.y; 
        }

        // check if shape with first and last point the same that was moved
        if (moveLast) {
            curPen.points[curPen.points.length-1].x = curPen.points[ptIndex].x;
            curPen.points[curPen.points.length-1].y = curPen.points[ptIndex].y;
        }

        // remove penItem and redraw it with new point
        //("HERE C", curPenObj); 
        //db.curPenContainer.removeAllChildren();
        curPenObj.graphics.clear();
        curPenObj = drawSavedPenItem(null, true, curPen);
        //lastPenItem = db.curPenObj;
        stage.update();
    
    });
    db.penLayer.addEventListener("pressup", function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
    
        canvas.classList.remove("grabbing-cursor");
        canvas.classList.add("grab-cursor");
        //e.target.cursor = "grab";
        //console.log("got pressup handleMove");
        db.penLayer.removeAllEventListeners('pressmove');
        db.penLayer.removeAllEventListeners('pressup');

        // change the points to rects and squares now since they aren't changed during pressmove
        if (inSquare || inRect) {
            curPen.points[1].x = curPen.points[2].x = curPen.width;
            curPen.points[2].y = curPen.points[3].y = curPen.height;
        }

        // put back the move background in the new shape if in edit mode
        if (db.pen.drawMode == DT_EDIT_MODE) {
            setMoveBackground(curPen);
        }
        else if (curPen.dt.toolType == DT_TOOL_MULTI_LINE && curPen.dt.drawType != DT_EDIT_MODE) {
             // restart othe multi-line watcher if in that tool
            // needed to stop and restart to prevent propagation
            watchMultiLine();
        }

        db.fileChanged = true;

        if (db.pen.drawMode == DT_EDIT_MODE ) {
            //curPen.dt.drawMode = DT_EDIT_MODE;
            cvGetDataUndoPush();
            //console.log("push edit undo",curPen);

        }
     
    });
    
}


export function setMoveBackground(penItem) {

// create a low alpha background shape in a larger line size to display behind the shape
// in order to be able to detect mouse drags
//console.log("set move background");

let backgroundDt = Object.assign({}, penItem.dt);   

backgroundDt.lineStartType = DT_END_POINT_NONE;
backgroundDt.lineEndType = DT_END_POINT_NONE;
backgroundDt.jointType = DT_MULTI_LINE_JOINT_NONE;
if (penItem.dt.highlight == DT_HIGHLIGHT_OFF) {
    backgroundDt.regLineSize = Math.max(penItem.dt.regLineSize, 30);
    backgroundDt.regColor =  "antiquewhite";
    //backgroundDt.alpha = .3;
}
else {
    backgroundDt.highlightColor = "antiquewhite";
    backgroundDt.highlightLineSize  = Math.max(penItem.dt.highlightLineSize , 30);
}
// draw the background shape using shape drawing routines, but with altered dt
let backShape = drawSavedPenItem(null, true, penItem, backgroundDt);
backShape.name = db.curPenIndex;
penItem.backgroundObj = backShape;

backShape.addEventListener('mousedown',watchMoveEditedPenObj);
return(backShape); 

}

export function clearPenMoveObj(penItem) {

    if (penItem.backgroundObj != null) {
        penItem.container.removeChild(penItem.backgroundObj);
    }
    stage.update();
}

// watcher for the background pen object to watch for mouse drags to move pen objects during edit mode
export function watchMoveEditedPenObj(e) {
    e.stopImmediatePropagation();

    // cancel edit watcher until done with move
    db.penLayer.removeAllEventListeners("mousedown");

    let curPenObjIndex = e.target.name;
    let backShape = db.penItemList[e.target.name].backgroundObj;
  
    //console.log("got press down in move event",e.target.name, e.target,backShape);
    let curPt;
    // Points are stored in the shapes.  The container coordinates are only used for move actions
    let startPress = getCorrectXY(db.penLayer);
    let startContainerX = db.curPenContainer.x;
    let startContainerY = db.curPenContainer.y;

   backShape.addEventListener('pressmove', function (e) {

        curPt = getCorrectXY(db.penLayer);
        db.curPenContainer.x = startContainerX + (curPt.x - startPress.x);
        db.curPenContainer.y = startContainerY + (curPt.y - startPress.y); 
        stage.update();
    })  

    backShape.addEventListener("pressup", function (e) {
        backShape.removeAllEventListeners('pressmove');
        backShape.removeAllEventListeners('pressup');
    })
    db.fileChanged = true;

    // replace edit event watcher
    db.penLayer.addEventListener('mousedown', watchEdit);
}

